<div class="card card-dark mb-0">
    <div class="card-header" *ngIf="showHeader">
        <h2 class="card-title">{{label}}</h2>
        <div class="card-tools">
            <div class="input-group input-group-sm" style="width: 200px;">
                <div class="input-group-append">
                    <span class="input-group-text bg-info"><i class="fas fa-search"></i></span>
                </div>
            </div>
        </div>
    </div>
    <div class="card-body p-0">
        <div class="table-responsive">
            <table class="table table-hover m-0">
                <thead>
                    <tr>
                        <th style="max-width: 110px;min-width: 110px;width: 110px;" class="text-center">Tipo Pago</th>
                        <th style="max-width: 120px;min-width: 120px;width: 120px;" class="cursor-pointer">Sistema</th>
                        <th style="max-width: 120px;min-width: 120px;width: 120px;" class="cursor-pointer">Cajero</th>
                        <th style="max-width: 120px;min-width: 120px;width: 120px;" class="cursor-pointer">Diferencia
                        </th>
                    </tr>
                </thead>
                <div class="progress-linear" *ngIf="isLoading">
                    <div class="container">
                        <div class="bar"></div>
                    </div>
                </div>
                <tbody *ngIf="!isLoading">
                    <tr *ngFor="let row of rows">
                        <td style="max-width: 110px;min-width: 110px;width: 110px;">
                            <span>{{row.nombre_tipopago}}</span>
                        </td>
                        <td style="max-width: 120px;min-width: 120px;width: 120px;">
                            <span>{{Func.currencyPeso(row.sistemaValue)}}</span>
                        </td>
                        <td style="max-width: 120px;min-width: 120px;width: 120px;">
                            <input type="text" placeholder="Ingrese valor" class="form-control form-control-sm"
                                [(ngModel)]="row.inputValue" (blur)="updateSum(row)" />
                        </td>
                        <td style="max-width: 120px;min-width: 120px;width: 120px;">
                            <span>{{ Func.currencyPeso(row.sum) }}</span>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td>Totales</td>
                        <td>{{ Func.currencyPeso(sistemaValueTotal) }}</td>
                        <td>{{ Func.currencyPeso(inputValueTotal) }}</td>
                        <td>{{ Func.currencyPeso(sumTotal) }}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</div>